module.exports = __webpack_public_path__ + "static/media/abicon1.7aac42ca.webp";